import * as pdfjsLib from "pdfjs-dist/webpack";

/**
 * Renders a PDF to a canvas element with dynamic scaling.
 * @param {string} pdfUrl - URL or data URL of the PDF.
 * @param {React.RefObject} canvasRef - Reference to the canvas element.
 * @param {Function} onLoad - Callback triggered after rendering (optional).
 */
export const renderPdfToCanvas = async (pdfUrl, canvasRef, onLoad) => {
  if (!pdfUrl || !canvasRef?.current) {
    onLoad?.();
    return;
  }

  try {
    const loadingTask = pdfjsLib.getDocument({
      url: pdfUrl,
      cMapUrl: "https://cdn.jsdelivr.net/npm/pdfjs-dist@3.4.120/cmaps/",
      cMapPacked: true,
    });

    const pdf = await loadingTask.promise;
    const page = await pdf.getPage(1);

    const canvas = canvasRef.current;
    if (!canvas) {
      onLoad?.();
      return;
    }

    const containerWidth = canvas.parentElement?.offsetWidth || 600;
    const unscaledViewport = page.getViewport({ scale: 1 });
    const scale = Math.min(containerWidth / unscaledViewport.width, 2);
    const viewport = page.getViewport({ scale });

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    const context = canvas.getContext("2d");

    context.clearRect(0, 0, canvas.width, canvas.height);

    await page.render({ canvasContext: context, viewport }).promise;
    onLoad?.();
  } catch (error) {
    console.error("PDF rendering failed:", error);
    onLoad?.();
  }
};
